import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';
import * as React from 'react';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { withClassname } from '@components/hoc/withClassname';
import { RequestsHolidayForm } from '@modules/hr-requests/holidays/RequestsHolidayForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const requestsHolidayUrl = '/metropolis/api/hr/workplan/request-holiday';
export const requestsHolidayLabel = 'Žádosti o dovolenou';
export const requestsHolidayPath = '/hr/requests/holiday';
export const requestsHolidayGridName = 'RequestsHolidayGrid';
export const RequestsHolidayGrid = compose(
  withRouter,
  setDisplayName(requestsHolidayGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: requestsHolidayLabel }]),
  withColumns(Agenda.REQUESTS_HOLIDAY),
  withProps(({ history, columns }) => ({
    name: requestsHolidayGridName,
    url: requestsHolidayUrl,
    Form: RequestsHolidayForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      history,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.REQUESTS_HOLIDAY} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-requests/holidays/RequestsHolidayGrid.tsx